import React, { Component } from "react";
import { rnds } from "./helpers";
import Rounds from "./Rounds";
import Grouping from "./Grouping";
import Tees from "./Tees";
import Msg from "./Msg";
import Pdf from "./Pdf";

class Pairings extends Component {
	constructor() {
		super();
		this.state = {
			sorted: [],
			results: [],
			msg: {},
			pdf: {},
		};
	}

	componentDidMount() {
		let rnd = rnds()[0]; /* hack to default to round 1 to start */
		let tee = 0; /* 0 = both 1 & 10 */

		if (this.props.match.params && this.props.match.params.rnd) {
			rnd = this.props.match.params.rnd;
		}
		if (this.props.match.params && this.props.match.params.tee) {
			tee = this.props.match.params.tee;
		}
		this.getMsg("teetimes", rnd);
		this.getPairings(rnd, tee);
	}

	componentWillReceiveProps(nextProps) {
		this.getMsg("teetimes", nextProps.match.params.rnd);
		this.getPairings(nextProps.match.params.rnd, nextProps.match.params.tee);
	}

	async getMsg(page, rnd) {
		this.setState({
			msg: {},
		});

		try {
			const response = await fetch(
				`https://valerotexasopen.com/api/public/msg?page=${page}&rnd=${rnd}`,
				{
					method: "GET",
				}
			);
			const json = await response.json();
			if (json && json.rnd) {
				this.state = {
					msg: json,
				};
			}
		} catch (error) {
			console.warn("Error", error);
		}
	}

	async getPairings(rnd, tee) {
		this.setState({
			sorted: [],
			results: [],
			pdf: {},
		});
		const f = `/api/public/teetimes`;

		try {
			const response = await fetch(
				`https://valerotexasopen.com/api/public/cdnNEW?f=${encodeURIComponent(
					f
				)}&rnd=${rnd}&tee=${tee}&ma=3600`,
				{
					method: "GET",
				}
			);
			const json = await response.json();
			if (json && json.results) {
				this.setState({
					sorted: json.results,
					results: json.results,
					pdf: json.pdf,
				});
			}
		} catch (error) {
			console.warn("Error", error);
		}
	}

	handleKeyUp() {
		const str = this.str.value.replace("'", "’").toLowerCase();
		if (str.length > 0) {
			let array = this.state.results.filter((item, index) => {
				let atLeastOne = false;
				for (let i = 0; i < item.players.length; i++) {
					let player = item.players[i];
					if (player.lname.toLowerCase().substring(0, str.length) === str) {
						atLeastOne = true;
					}
				}
				return atLeastOne;
			});
			this.setState({
				sorted: array,
			});
		} else {
			this.setState({
				sorted: this.state.results,
			});
		}
	}

	render() {
		const groups = this.state.sorted.map((item, index) => {
			return (
				<div key={item.grp}>
					<h3>
						{item.time} – {item.block}
					</h3>
					<Grouping
						players={item.players}
						str={this.str.value.replace("'", "’").toLowerCase()}
					/>
				</div>
			);
		});

		return (
			<div>
				<Rounds {...this.props} />
				<div className="page-break" />
				<Tees {...this.props} />
				<div className="page-break" />
				<form className="form-inline players">
					<div className="form-group">
						<div className="input-group">
							<div
								className="input-group-addon"
								style={{ backgroundColor: "#ebf5fa" }}
							>
								<i className="fa fa-search" /> &nbsp; Search:
							</div>
							<input
								type="text"
								className="form-control"
								ref={(ref) => (this.str = ref)}
								onKeyUp={this.handleKeyUp.bind(this)}
								placeholder="Player’s last name"
							/>
						</div>
					</div>
				</form>
				<Msg msg={this.state.msg} />
				<Pdf pdf={this.state.pdf} />
				{groups}
			</div>
		);
	}
}

export default Pairings;



// WEBPACK FOOTER //
// ./src/Pairings.js